import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput as DocUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import {
  Grid,
  ListItem,
  ListItemText,
  ListSubheader,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { DropdownTextfield } from 'containers/ARAPModule/Components/DropdownTextField'
import {
  baseAmount,
  calculateDocAmt,
} from 'containers/ARAPModule/Helper/AmountCalculation'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  CommonStatus,
  DocumentListingDocument,
  GetArAdvanceDocument,
  RecordStatus,
  useCreateArAdvanceMutation,
  useDocumentListingLazyQuery,
  useGetBankAccountQuery,
  useGetCreditCardTypeQuery,
  useGetDebtorAccountListingQuery,
  useGetDocNumTitleQuery,
  useGetDocumentDateValidationQuery,
  useGetPaymentMethodQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateArAdvanceMutation,
} from 'generated/graphql'
import { calculateTaxDetail } from 'helpers/Calculation/taxCalculationDetail'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  getDatePlusDay,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../ARAdvance.scss'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
interface ARAdvanceProps {
  TrxDate: string
  CompanyID: string
  DebtorAccountID: string
  AdvanceID: string
  DocDate: Date
  DocAmt: number
  RefNo: string
  Description: string
  Remark: string
  Attachment: null
  debitAmt: number
  approval: string
  user: string
  BankAccountID: string
  BankName: string
  PaymentMethodID: string
  CreditCardID: string
  ChequeNo: string
  ChequeDate: Date
  Amount: number
  TaxSchemeID: string
  TaxRate: number
  TaxAmt: number
  TaxInvoiceNo: string
  uploadAttach: string
  TaxAmtDetail: any
}

export const ARAdvanceForm = (props: any) => {
  const { formMode, type } = props

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const { CompanyID, AdvanceID }: any = useParams()
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [openExitDialog, setopenExitDialog] = useState(false)
  const [PaymentValidation, setPaymentValidation] = useState(false)
  const [valuepicked, setValuePicked] = useState<String>(null)
  const [voiceRemark, setVoiceRemark] = useState('')

  // Change Tax descrition into code number
  const [selectedTax, setSelectedTax] = useState(null)
  const [initDocs, setInitDocs] = useState([])
  const [cost, setCost] = useState<number>(editData?.Amount ?? 0)
  const [taxPerc, setTaxPerc] = useState(0)
  const [totalAmt, setTotalAmt] = useState(0.0)
  const [amount, setAmount] = useState(0.0)
  const [taxAmt, setTaxAmt] = useState(!!editData ? editData?.TaxAmt : 0)
  const [record, setRecord] = useState(false)
  const [singleRemark, setSingleRemark] = useState(null)
  const [audioInput, setAudioInput] = useState(editData?.Remark ?? '')
  const [text, setText] = useState(editData?.Remark ?? '')
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const docAmt = calculateDocAmt(cost, taxAmt)

  //Creditor Account Company Assignment//
  // const {
  //   loading: DebtorAccountLoading,
  //   data: { getDebtorAccount } = { getDebtorAccount: [] },
  // } = useGetDebtorAccountQuery({
  //   fetchPolicy: 'network-only',
  //   variables: { CompanyID },
  //   onError: ({ message }) => {
  //     let error = message?.substring(15)
  //     setErrMessage(error)
  //     setErrDialog(true)
  //   },
  // })

  const {
    loading: DebtorAccountLoading,
    data: { getDebtorAccountListing } = { getDebtorAccountListing: [] },
  } = useGetDebtorAccountListingQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //PaymentMethod
  const {
    loading: PaymentMethodLoading,
    data: { getPaymentMethod } = { getPaymentMethod: [] },
  } = useGetPaymentMethodQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {},
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: bankAccountLoading,
    data: { getBankAccount } = { getBankAccount: [] },
  } = useGetBankAccountQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RecordStatus: RecordStatus?.Active },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'AR_Advance' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //CreditCardType
  const {
    loading: CreditCardTypeLoading,
    data: { getCreditCardType } = { getCreditCardType: [] },
  } = useGetCreditCardTypeQuery({
    fetchPolicy: 'network-only',
    variables: {},
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  // Tax
  // const {
  //   loading: TaxSchemeInputLoading,
  //   data: { getTaxSchemeListing: getTaxSchemeInputListing } = {
  //     getTaxSchemeListing: [],
  //   },
  // } = useGetTaxSchemeNewListingQuery({
  //   fetchPolicy: 'network-only',
  //   variables: { CommonStatus: CommonStatus.Active, TaxClass: 'INPUT' },
  //   onError: ({ message }) => {
  //     let error = message?.substring(15)
  //     setErrMessage(error)
  //     setErrDialog(true)
  //   },
  //   onCompleted: () => {
  //     if (!!editData) {
  //       setSelectedTax(taxScheme?.find(x => x?.id === editData?.TaxSchemeID))
  //     }
  //   },
  // })

  // const {
  //   loading: TaxSchemeOutputLoading,
  //   data: { getTaxSchemeListing: getTaxSchemeOutputListing } = {
  //     getTaxSchemeListing: [],
  //   },
  // } = useGetTaxSchemeNewListingQuery({
  //   fetchPolicy: 'network-only',
  //   variables: { CommonStatus: CommonStatus.Active, TaxClass: 'OUTPUT' },
  //   onError: ({ message }) => {
  //     let error = message?.substring(15)
  //     setErrMessage(error)
  //     setErrDialog(true)
  //   },
  // })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMessage(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  const ARAdvanceFormSchema = yup.object().shape({
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
    DebtorAccountID: yup.string().required('DebtorAccountID is Required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    // AdvanceID: CommonYupValidation.requireField(SystemMsgs.journalType()),
    PaymentMethodID: CommonYupValidation.requireField(
      'Payment Method is required'
    ),
    CreditCardID:
      PaymentValidation && valuepicked?.includes('Card')
        ? CommonYupValidation.requireField('Credit Card Type is required')
        : null,
    ChequeNo: yup.string().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.string().required('Cheque no. is required'),
      otherwise: null,
    }),
    ChequeDate: yup.date().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.date().required('Cheque date is required'),
      otherwise: null,
    }),

    BankAccountID: CommonYupValidation.requireField('Bank Account is required'),
    // TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
    Amount: yup
      .string()
      .required('Amount is required')
      .test('sumZero', 'Amount should not be zero', val => {
        return parseFloat(amtNumStr(val)) !== 0
      }),
  })

  const {
    handleSubmit,
    register,
    errors,
    control,
    getValues,
    watch,
    setValue,
    clearErrors,
    reset,
    formState: { isSubmitted },
  } = useForm<ARAdvanceProps>({
    defaultValues: {
      CompanyID: !!editData ? editData?.CompanyID : '',
      DocDate: !!editData ? editData?.DocDate : new Date(),
      TrxDate: editData ? editData?.TransactionDate : new Date(),
      RefNo: !!editData ? editData?.RefNo : '',
      DebtorAccountID: !!editData ? editData?.CreditAccountID : '',
      BankAccountID: !!editData ? editData?.BankAccountID : '',
      PaymentMethodID: !!editData ? editData?.PaymentMethodID : '',
      CreditCardID: !!editData ? editData?.CreditCardID : '',
      ChequeNo: !!editData ? editData?.ChequeNo : '',
      ChequeDate: !!editData ? editData?.ChequeDate : new Date(),
      // TaxSchemeID: !!editData ? editData?.TaxSchemeID : '',
      // TaxRate: !!editData ? editData?.TaxRate : '',
      TaxInvoiceNo: !!editData ? editData?.TaxInvoiceNo : '',
      // TaxAmt: !!editData ? editData?.TaxAmt : 0,
      DocAmt: !!editData ? editData?.DocAmt : 0,
      Amount: !!editData ? editData?.Amount : 0,
      Description: !!editData ? editData?.Description : '',
      Remark: !!editData ? editData?.Remark : '',
      Attachment: !!editData ? editData?.Attachment : '',
      TaxAmtDetail: [],
    },
    mode: 'onSubmit',
    resolver: yupResolver(ARAdvanceFormSchema),
  })

  const [selectedBank, setSelectedBank] = useState(null)
  // select bank
  const handleBankChange = event => {
    setSelectedBank(
      getBankAccount.find(x => x?.BankAccountID === event?.target?.value)
    )
  }

  const handlePMChange = event => {
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque' ||
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setPaymentValidation(true)
    } else setPaymentValidation(false)
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque'
    ) {
      setValuePicked('Cheque')
    } else if (
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setValuePicked('Card')
    } else setValuePicked('')
  }

  //Changing If PM chosed CreditCard
  const [selectedCC, setSelectedCC] = useState(null)
  const creditcard: any = getCreditCardType

  const handleCCChange = event => {
    setSelectedCC(
      creditcard.find(x => x?.CreditCardID === event?.target?.value)
    )
  }

  // To get list of Tax Code that has been effective //
  // const taxEffectiveDate: any =
  //   !!watch('DocDate') && watch('DocDate').toString() !== 'Invalid Date'
  //     ? new Date(new Date(watch('DocDate')).getTime() + 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .slice(0, 10)
  //     : null

  // const taxSchemeInput = getTaxSchemeInputListing?.filter(
  //   el =>
  //     el?.taxSchemeDetailList?.filter(y => {
  //       return new Date(y?.effectiveDate).toISOString() <= taxEffectiveDate
  //     })?.length > 0
  // )

  // const taxSchemeOutput = getTaxSchemeOutputListing?.filter(
  //   el =>
  //     el?.taxSchemeDetailList?.filter(y => {
  //       return new Date(y?.effectiveDate).toISOString() <= taxEffectiveDate
  //     })?.length > 0
  // )

  // const taxScheme = [...taxSchemeInput, ...taxSchemeOutput]

  // ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ - TAX CALCULATION - ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ //

  // const prepareTaxCalculationData = (selectedTax: any) => {
  //   if (!selectedTax?.taxSchemeDetailList[0]?.taxSchemeDetailItemList?.length) {
  //     return []
  //   }

  //   const taxSchemeDetail = selectedTax?.taxSchemeDetailList[0]

  //   return taxSchemeDetail.taxSchemeDetailItemList.map(item => ({
  //     taxId: item.taxId,
  //     taxSchemeId: taxSchemeDetail.taxSchemeId,
  //     taxSchemeDetailId: taxSchemeDetail.id,
  //     seqNo: item.seqNo,
  //     taxOnSeq: item.taxOnSeq || [],
  //     computeMethod:
  //       item.computeMethod === 'TAX_ON_GROSS'
  //         ? 'Tax_On_Gross'
  //         : 'Tax_On_Taxed_Price',
  //     taxRate: item.taxRate,
  //     taxCode: item.taxInfo?.code,
  //   }))
  // }

  // const calculateTaxFromState = (selectedTax: any, amount: number) => {
  //   const taxData = prepareTaxCalculationData(selectedTax)

  //   const isExclusive = Boolean(selectedTax?.isExclusive)

  //   return calculateTaxDetail(taxData, amount, isExclusive)
  // }
  // let result = calculateTaxFromState(selectedTax, cost)

  // useEffect(() => {
  //   if (formMode === 'edit') {
  //     let selectTax = taxSchemeInput.find(x => x?.id === editData?.TaxSchemeID)
  //     setSelectedTax(selectTax)
  //     initializeTaxDetailsInEditMode()
  //   }
  // }, [formMode])

  // const initializeTaxDetailsInEditMode = () => {
  //   if (formMode === 'edit' && editData?.TaxSchemeID) {
  //     const selectTax = taxSchemeInput.find(
  //       x => x?.id === editData?.TaxSchemeID
  //     )
  //     setSelectedTax(selectTax)
  //     if (editData?.TaxAmtDetails && Array.isArray(editData?.TaxAmtDetails)) {
  //       editData.TaxAmtDetails.forEach((taxDetail, index) => {
  //         register(`TaxAmtDetail[${index}]`)
  //         setValue(`TaxAmtDetail[${index}]`, taxDetail.taxAmount)
  //       })
  //       setValue('taxDetailsCount', editData.TaxAmtDetails.length)
  //     } else if (selectTax) {
  //       const currentAmount = baseAmount(
  //         Number(editData?.Quantity),
  //         Number(editData?.UnitPrice)
  //       )
  //       const taxResult = calculateTaxFromState(selectTax, currentAmount)
  //       if (taxResult?.taxDetails) {
  //         updateTaxDetailsInForm(taxResult.taxDetails, taxResult.TaxAmount)
  //       }
  //     }
  //   }
  // }

  // const updateTaxDetailsInForm = (taxDetails, taxAmount) => {
  //   if (!taxDetails || taxDetails.length === 0) return
  //   const prevTaxDetailsCount = watch('taxDetailsCount') || 0
  //   taxDetails.forEach((tax, index) => {
  //     register(`TaxAmtDetail[${index}]`)
  //     setValue(`TaxAmtDetail[${index}]`, tax.TaxAmount)
  //   })
  //   setValue('taxDetailsCount', taxDetails.length)
  //   if (prevTaxDetailsCount > taxDetails.length) {
  //     for (let i = taxDetails.length; i < prevTaxDetailsCount; i++) {
  //       setValue(`TaxAmtDetail[${i}]`, null)
  //     }
  //   }
  //   setValue('TaxAmt', taxAmount)
  //   setTaxAmt(taxAmount)
  // }

  const handleAmtChange = event => {
    let amtChange = parseFloat(event?.value)
    setCost(amtChange)
    setValue('Amount', amtChange)
    // if (selectedTax) {
    //   prepareTaxCalculationData(selectedTax)
    //   const taxResult = calculateTaxFromState(selectedTax, event.value)
    //   setTaxAmt(taxResult?.TaxAmount)
    //   updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)
    //   setValue(
    //     'TaxAmt',
    //     calculateTaxFromState(selectedTax, event.value)?.TaxAmount
    //   )
    // }
  }

  // const handleTaxChange = event => {
  //   const currentTax = taxScheme.find(x => x?.id === event?.target?.value)
  //   const taxResult = calculateTaxFromState(currentTax, cost)
  //   updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)
  //   setSelectedTax(currentTax)
  //   setTaxAmt(taxResult?.TaxAmount)
  // }

  // const handleTaxAmtChange = event => {
  //   setTaxAmt(event.value)
  // }

  // change tax amount(controller) *taxAmtChangeableNeeded only
  // useEffect(() => {
  //   if (!isNaN(taxAmt)) {
  //     setValue('TaxAmt', taxAmt)
  //     clearErrors('TaxAmt')
  //   }
  // }, [taxAmt])

  // Autoset tax after select tax amount
  // useEffect(() => {
  //   if (!!selectedTax) {
  //     setValue('TaxSchemeID', selectedTax?.id)
  //     clearErrors('TaxSchemeID')
  //   }
  // }, [selectedTax])

  // useEffect(() => {
  //   if (!!editData && !!taxScheme) {
  //     // set tax on edit
  //     setSelectedTax(taxScheme?.find(x => x?.id === editData?.TaxSchemeID))
  //   }
  // }, [editData, taxScheme])

  // Edit Bank Account
  useEffect(() => {
    if (!!editData && !!getBankAccount) {
      setSelectedBank(
        getBankAccount?.find(e => e?.BankAccountID === editData?.BankAccountID)
      )
    }
  }, [editData, getBankAccount])

  //////////////////////////////////////
  //...........ATTACHMENTS.............//
  ///////////////////////////////////////
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    loadDoc,
    { loading: DocLoad, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  useEffect(() => {
    if (!DocLoad && formMode !== 'add') {
      loadDoc({ variables: { refID: AdvanceID } })
    }
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, AdvanceID, editData])

  const [
    createARAdvance,
    {
      loading: createARAdvanceLoading,
      called: createARAdvanceCalled,
      error: createARAdvanceError,
    },
  ] = useCreateArAdvanceMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({
          pathname: `/account-receivable/${CompanyID}/advance`,
          state: { success: true, msgMode: 'create' },
        })
      }, 500)
    },
  })

  const [
    updateARAdvance,
    {
      loading: updateARAdvanceLoading,
      called: updateARAdvanceCalled,
      error: updateARAdvanceError,
    },
  ] = useUpdateArAdvanceMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      mode === 'approve-reject'
        ? setTimeout(() => {
            history.push({
              pathname: `/account-receivable/${CompanyID}/advance`,
              state: { success: true, msgMode: 'update' },
            })
          }, 500)
        : setTimeout(() => {
            history.push({
              pathname: `/account-receivable/${CompanyID}/advance`,
              state: { success: true, msgMode: 'update' },
            })
          }, 500)
    },
  })

  const [val, setVal] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)

  const onSubmit = (data, status) => {
    if (val == false) {
      setVal(true)
      if (formMode === 'add') {
        // if (
        //   getDocumentNumberHeader?.filter(x => x?.RefTable === 'AR_Advance')?.length === 0
        // ) {
        //   setOpenSnackBar(true)
        //   setSnackBarMsg(SystemMsgs.errorNumberingStructure())
        // } else {
        createARAdvance({
          variables: {
            input: {
              CompanyID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              RefNo: data?.RefNo,
              DebtorAccountID: data?.DebtorAccountID,
              PaymentMethodID: data?.PaymentMethodID,
              CreditCardID: data?.CreditCardID,
              BankAccountID: data?.BankAccountID,
              Description: data?.Description,
              Remark: data?.Remark,
              Attachment: files,
              ChequeNo: data?.ChequeNo,
              ChequeDate: data?.ChequeDate,
              ChequeExpiryDate: !!data?.ChequeDate
                ? changeDateFormat(
                    getDatePlusDay(data?.ChequeDate, 180),
                    'DD MMM YYYY'
                  )
                : null,
              ApprovalStatus: statusInput(status),
              //TAX
              // TaxSchemeID: data?.TaxSchemeID,
              Amount: parseFloat(amtNumStr(data?.Amount)),
              DocAmtBeforeTax: parseFloat(amtNumStr(data?.Amount)),
              // TaxRate: 0,
              // TaxAmt: parseFloat(data?.TaxAmt),
              DocAmt: docAmt,
              TaxInvoiceNo: data?.TaxInvoiceNo,
              // BalanceAmt: getTotalAmt(true, cost, taxAmt, TaxRate),
            },
          },
          refetchQueries: [
            { query: GetArAdvanceDocument },
            { query: DocumentListingDocument },
          ],
        })
        // }
      } else if (formMode !== 'add') {
        updateARAdvance({
          variables: {
            input: {
              CompanyID,
              AdvanceID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              RefNo: data?.RefNo,
              DebtorAccountID: data?.DebtorAccountID,
              PaymentMethodID: data?.PaymentMethodID,
              CreditCardID: data?.CreditCardID,
              BankAccountID: data?.BankAccountID,
              Description: data?.Description,
              Remark: data?.Remark,
              Attachment: files,
              ChequeNo: data?.ChequeNo,
              ChequeDate: data?.ChequeDate,
              ChequeExpiryDate: !!data?.ChequeDate
                ? changeDateFormat(
                    getDatePlusDay(data?.ChequeDate, 180),
                    'DD MMM YYYY'
                  )
                : null,
              ApprovalStatus: statusInput(status),
              // TaxSchemeID: data?.TaxSchemeID,
              Amount: parseFloat(amtNumStr(data?.Amount)),
              DocAmtBeforeTax: parseFloat(amtNumStr(data?.Amount)),
              // TaxRate: 0,
              // TaxAmt: parseFloat(data?.TaxAmt),
              DocAmt: docAmt,
              TaxInvoiceNo: data?.TaxInvoiceNo,
            },
          },
          refetchQueries: [
            { query: GetArAdvanceDocument },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: AdvanceID,
              },
            },
          ],
        })
      }
    }
  }

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  const createUpdateLoading = editData
    ? updateARAdvanceLoading
    : createARAdvanceLoading

  const createUpdateCalled = editData
    ? updateARAdvanceCalled
    : createARAdvanceCalled

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? true : false
  const checkingYearClose2 = openPeriod2 ? false : true

  /* -------------------------------------------- */
  /*               DOC DATE VALIDATION            */
  /* -------------------------------------------- */
  const DocDate = watch('DocDate') ? new Date(watch('DocDate')) : null
  const today = new Date()

  const monthsBefore = getDocumentDateValidation?.[0]?.MonthsBefore ?? 12
  const monthsAfter = getDocumentDateValidation?.[0]?.MonthsAfter ?? 1

  // Calculate valid range
  const minValidDate = new Date(today)
  minValidDate.setMonth(minValidDate.getMonth() - monthsBefore)
  minValidDate.setHours(0, 0, 0, 0)

  const maxValidDate = new Date(today)
  maxValidDate.setMonth(maxValidDate.getMonth() + monthsAfter)
  maxValidDate.setHours(23, 59, 59, 999)

  // Validate inclusive range
  const isDocDateInvalid =
    DocDate &&
    (DocDate.getTime() < minValidDate.getTime() ||
      DocDate.getTime() > maxValidDate.getTime())

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: { type: 'submit' },

    disabled:
      checkingYearClose2 || isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccReceivableAdvancesDraft,
          }),
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: { type: 'submit' },

    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.DebtorAccountID ||
      !!errors?.PaymentMethodID ||
      !!errors?.Amount ||
      !!errors?.TaxSchemeID ||
      !!errors?.BankAccountID ||
      !!errors?.Description ||
      checkingYearClose2 ||
      isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccReceivableAdvancesUpdate,
          }),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      handleSubmit(data =>
        getDocumentNumberHeader?.filter(x => x?.RefTable === 'AR_Advance')
          ?.length === 0
          ? (setOpenSnackBar(true),
            setSnackBarMsg(SystemMsgs.errorNumberingStructure()))
          : !createUpdateCalled && onSubmit(data, 'submit')
      )()
    },
    color: 'primary',
    props: { type: 'submit' },
    disabled: checkingYearClose2 || isDocDateInvalid ? true : false,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  const [openExitConf, setOpenExitConf] = useState(null)

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      formMode: formMode,
    })

  return (
    <>
      {bankAccountLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {PaymentMethodLoading && <Loading />}
      {CreditCardTypeLoading && <Loading />}
      {/* {TaxSchemeInputLoading && <Loading />} */}
      {createARAdvanceLoading && <Loading />}
      {updateARAdvanceLoading && <Loading />}
      {/* {TaxSchemeOutputLoading && <Loading />} */}
      {openPeriodCheckDateLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/account-receivable/${CompanyID}/advance`)
          localStorage.removeItem('DebitAmt')
        }}
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Payable' },
          { name: 'AP Submenu' },
          { name: 'Advance Listing' },
          { name: 'Advance', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              mode === 'add'
                ? 'New'
                : mode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />
      {!DebtorAccountLoading && (
        <ContentWrapper float footer>
          <CardContents
            section={{
              header: {
                title: (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span>Advance Details</span>
                    {formMode === 'edit' && (
                      <IconText
                        icon={
                          <img
                            src={AuditLog}
                            style={{
                              width: '17px',
                              marginLeft: '12px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/advance/${AdvanceID}/detail/audit-log`,
                                state: {
                                  ID: editData?.AdvanceID,
                                  tableName: 'AR_Advance',
                                  primaryKey: 'AdvanceID',
                                  ...editData,
                                },
                              })
                            }}
                          />
                        }
                        font="desc"
                      />
                    )}
                  </div>
                ),
              },
            }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                required
                as={KeyboardDatePicker}
                name="DocDate"
                label="Document Date"
                control={control}
                onChange={(date: Date | null) => {}}
                format="dd/MM/yyyy"
                value={watch(
                  formMode === 'add' ? new Date() : editData?.DocDate
                )}
                margin="dense"
                allowKeyboardControl
                ref={register}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                defaultValue={editData ? editData?.DocDate : new Date()}
                showTodayButton
                className="left"
                disabled={mode == 'approve-reject'}
                helperText={
                  isDocDateInvalid
                    ? 'Document date is not within the validation range'
                    : errors?.DocDate?.message
                }
                error={errors?.DocDate || isDocDateInvalid ? true : false}
              />
            </MuiPickersUtilsProvider>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                as={KeyboardDatePicker}
                name="TrxDate"
                required
                label="Transaction Date"
                control={control}
                format="dd/MM/yyyy"
                margin="dense"
                allowKeyboardControl
                onChange={(date: Date | null) => {}}
                ref={register}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                showTodayButton
                className="right"
                value={new Date()}
                defaultValue={editData ? editData?.TransactionDate : new Date()}
                helperText={
                  checkingYearClose2
                    ? 'Financial Period already closed'
                    : errors?.TrxDate?.message
                }
                error={errors?.TrxDate || checkingYearClose2 ? true : false}
                minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
                maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              />
            </MuiPickersUtilsProvider>
            <Controller
              as={TextField}
              id="standard-basic"
              name="RefNo"
              label="Reference No."
              required
              autoComplete="off"
              control={control}
              // className="right"
              margin="dense"
              ref={register}
              helperText={errors?.RefNo?.message}
              error={errors?.RefNo ? true : false}
              defaultValue={editData ? editData?.RefNo : ''}
              disabled={mode == 'approve-reject'}
            />
            <Controller
              render={({ value, onChange }) => {
                const defVal = getDebtorAccountListing?.filter(
                  x => x?.DebtorAccountID === editData?.DebtorAccountID
                )[0]
                return (
                  <Autocomplete
                    options={
                      getDebtorAccountListing?.sort((a, b) => {
                        return a?.DebtorName?.localeCompare(b?.DebtorName)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.DebtorName}`}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('DebtorAccountID', newValue?.DebtorAccountID)
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.DebtorName}</span>
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.DebtorAccountID?.message}
                            error={errors?.DebtorAccountID ? true : false}
                            label="Debtor Name"
                            style={{ width: '100%' }}
                            margin="dense"
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Debtor Name"
              name="DebtorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.DebtorAccountID?.message}
              error={errors?.DebtorAccountID ? true : false}
              defaultValue={editData?.DebtorAccountID}
              required
              disabled={mode === 'approve-reject'}
            />
            <Controller
              render={({ onChange, value }) => (
                <TextField
                  label="Payment Method"
                  required
                  margin="dense"
                  select
                  value={value}
                  onChange={e => {
                    onChange()
                    handlePMChange(e)
                    setValue('PaymentMethodID', e?.target?.value)
                  }}
                  defaultValue={editData ? editData?.PaymentMethodID : ''}
                  disabled={formMode === 'approve-reject'}
                  helperText={errors?.PaymentMethodID?.message}
                  error={errors?.PaymentMethodID ? true : false}
                >
                  {getPaymentMethod
                    ?.sort((a, b) => {
                      return a.Name.localeCompare(b.Name)
                    })
                    .map((el, index) => (
                      <MenuItem key={index} value={el.PaymentMethodID}>
                        {el.Name}
                      </MenuItem>
                    ))}
                </TextField>
              )}
              control={control}
              helperText={errors?.PaymentMethodID?.message}
              error={errors?.PaymentMethodID ? true : false}
              onChange={e => {
                //handlePMChange(e)
                setValue('PaymentMethodID', e?.target?.value)
              }}
              ref={register()}
              name="PaymentMethodID"
              autoComplete="off"
              value={editData?.PaymentMethodID}
              margin="dense"
              multiline={true}
              fullWidth
              required
            />
            {getPaymentMethod
              .find(el => el.PaymentMethodID === watch('PaymentMethodID'))
              ?.Name?.includes('Card') && (
              <Controller
                render={({ onChange, value }) => (
                  <TextField
                    select
                    required
                    name="CreditCardID"
                    label="Card Type"
                    onChange={e => {
                      onChange(e)
                      handleCCChange(e)
                    }}
                    defaultValue={editData ? editData?.CreditCardID : ''}
                    disabled={mode == 'approve-reject'}
                  >
                    {getCreditCardType
                      ?.sort((a, b) => {
                        return a.Name.localeCompare(b.Name)
                      })
                      .map((el, index) => (
                        <MenuItem key={index} value={el.CreditCardID}>
                          {`${el.Name}`}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
                label="Card Type"
                name="CreditCardID"
                autoComplete="off"
                control={control}
                // helperText={errors?.CreditCardID?.message}
                // error={errors?.CreditCardID ? true : false}
                multiline={true}
                // defaultValue={getPayment[0]?.CreditCardID}
                fullWidth
                margin="dense"
                ref={register}
              />
            )}
            {getPaymentMethod.find(
              el => el.PaymentMethodID === watch('PaymentMethodID')
            )?.Name === 'Cheque' && (
              <>
                <Controller
                  as={TextField}
                  id="standard-basic"
                  name="ChequeNo"
                  label="Cheque No"
                  className="left"
                  autoComplete="off"
                  control={control}
                  margin="dense"
                  required
                  ref={register}
                  defaultValue={editData ? editData?.ChequeNo : ''}
                  disabled={mode == 'approve-reject'}
                />
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Controller
                    required
                    as={KeyboardDatePicker}
                    name="ChequeDate"
                    label="Cheque Date"
                    control={control}
                    onChange={(date: Date | null) => {}}
                    format="dd/MM/yyyy"
                    value={watch('ChequeDate')}
                    margin="dense"
                    allowKeyboardControl
                    ref={register}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    defaultValue={
                      formMode === 'add' ? new Date() : editData?.ChequeDate
                    }
                    showTodayButton
                    className="right"
                    disabled={mode == 'approve-reject'}
                  />
                </MuiPickersUtilsProvider>
              </>
            )}
            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              id="standard-basic"
              name="Amount"
              label="Amount"
              value={cost}
              autoComplete="off"
              control={control}
              onValueChange={e => {
                handleAmtChange(e)
              }}
              decimalScale={2}
              fixedDecimalScale
              margin="dense"
              required
              fullWidth
              helperText={errors?.Amount?.message}
              error={errors?.Amount ? true : false}
              ref={register()}
              defaultValue={editData?.Amount || ''}
            />
            {/* <Grid item xs={12}>
              {!TaxSchemeInputLoading && !TaxSchemeOutputLoading && (
                <Controller
                  as={
                    <TextField
                      margin="normal"
                      label="Tax Scheme"
                      required
                      SelectProps={{
                        renderValue: () => `${selectedTax?.name}`,
                        onChange: event => {
                          handleTaxChange(event)
                          setValue(
                            'TaxSchemeID',
                            event?.target?.value as string
                          )
                          clearErrors('TaxSchemeID')
                        },
                      }}
                      select
                      helperText={errors?.TaxSchemeID?.message}
                      error={errors?.TaxSchemeID ? true : false}
                      fullWidth
                    >
                      <ListSubheader>Input</ListSubheader>
                      {taxSchemeInput?.map((taxScheme, index) => (
                        <MenuItem
                          id="tax-select"
                          key={index}
                          value={taxScheme?.id}
                        >
                          {
                            <div className="content-wrap full">
                              <div>
                                <span className="xsTitle">
                                  {taxScheme?.name}
                                </span>
                              </div>
                              <div className="desc">
                                {taxScheme?.description}
                              </div>
                            </div>
                          }
                        </MenuItem>
                      ))}
                      <ListSubheader>Output</ListSubheader>
                      {taxSchemeOutput?.map((taxScheme, index) => (
                        <MenuItem
                          id="tax-select"
                          key={index}
                          value={taxScheme?.id}
                        >
                          {
                            <div className="content-wrap full">
                              <div>
                                <span className="xsTitle">
                                  {taxScheme?.name}
                                </span>
                              </div>
                              <div className="desc">
                                {taxScheme?.description}
                              </div>
                            </div>
                          }
                        </MenuItem>
                      ))}
                    </TextField>
                  }
                  select
                  name="TaxSchemeID"
                  autoComplete="off"
                  defaultValue={editData?.TaxSchemeID || ''}
                  ref={register()}
                  control={control}
                />
              )}
            </Grid>
            {result.taxDetails.length > 0 && (
              <Grid item xs={12}>
                <Paper
                  elevation={1}
                  style={{
                    padding: '1px 7px',
                    borderRadius: '2px',
                    backgroundColor: '#fff9f2',
                  }}
                >
                  {result.taxDetails.map((tax, index) => (
                    <Grid container key={index} spacing={1} alignItems="center">
                      <Grid item xs={4}>
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: '0.63rem',
                            fontWeight: 500,
                            lineHeight: '24px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {tax?.taxCode || `Tax ${index + 1}`}
                        </Typography>
                      </Grid>

                      <Grid item xs={3}>
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: '0.63rem',
                            fontWeight: 500,
                            lineHeight: '24px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {typeof tax?.TaxRate === 'number'
                            ? `${(tax.TaxRate * 100).toFixed(2)}%`
                            : `N/A`}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Controller
                          name={`TaxAmtDetail[${index}]`}
                          control={control}
                          defaultValue={tax.TaxAmount}
                          render={({ onChange, value }) => (
                            <NumberFormat
                              customInput={TextField}
                              fullWidth
                              className="disabled-input"
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              style={{
                                marginTop: '10px',
                                fontSize: '0.63rem',
                              }}
                              allowNegative={false}
                              size="small"
                              value={
                                watch(`TaxAmtDetail[${index}]`) ?? tax.TaxAmount
                              }
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                                style: {
                                  alignSelf: 'center',
                                  fontSize: '0.63rem',
                                  height: '23px',
                                  width: '150px',
                                  padding: '0 4px',
                                },
                              }}
                              InputLabelProps={{
                                style: { display: 'none' },
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Paper>
              </Grid>
            )} */}
            {/* <Grid item xs={12} style={{ height: '16px' }} /> */}
            {/* <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register()}
              control={control}
              margin="dense"
              name="TaxAmt"
              label="Tax Amount"
              onValueChange={e => {
                handleTaxAmtChange(e)
                setTaxAmt(e?.floatValue)
              }}
              value={taxAmt}
              defaultValue={editData?.TaxAmt ?? taxAmt ?? 0}
              decimalScale={2}
              fixedDecimalScale
              className="left"
              InputProps={{ disableUnderline: true, readOnly: true }}
            /> */}
            {/* <Controller
              render={({ value, onChange }) => {
                value = { docAmt }
                return (
                  <TextField
                    margin="dense"
                    label="Total Amount"
                    value={amtStr(docAmt)}
                    InputProps={{ readOnly: true, disableUnderline: true }}
                    className="right"
                    disabled
                  />
                )
              }}
              disabled
              margin="dense"
              defaultValue={(docAmt || 0) ?? (editData?.DocAmt || 0)}
              name="DocAmt"
              ref={register()}
              control={control}
            /> */}

            <Controller
              as={TextField}
              fullWidth
              helperText={errors?.TaxInvoiceNo?.message}
              error={errors?.TaxInvoiceNo ? true : false}
              autoComplete="off"
              margin="dense"
              name="TaxInvoiceNo"
              label="Tax Invoice No."
              control={control}
              ref={register}
            />

            <DropdownTextfield
              // mount={bankNameNeeded}
              disabled={formMode === 'approve-reject' ? true : false}
              helperText={errors?.BankAccountID?.message}
              error={errors?.BankAccountID ? true : false}
              label="Bank Account No"
              handleChangeEnabled
              handleChange={handleBankChange}
              selectProps={{
                renderValue: () =>
                  `${selectedBank?.AccountNo} (${selectedBank?.BankProfile?.Name} | ${selectedBank?.Code})`,
              }}
              customDropdown={getBankAccount?.map((el, index) => (
                <MenuItem
                  id="contract-select"
                  key={index}
                  value={el?.BankAccountID}
                >
                  <div className="content-wrap full">
                    <div>
                      <span className="xsTitle">
                        {el.BankProfile?.Name} ({el.BankProfile?.Address?.city})
                      </span>
                    </div>
                    <div className="desc">
                      Account No: {`${el?.AccountNo} (${el?.Code})`}
                    </div>
                  </div>
                </MenuItem>
              ))}
              name="BankAccountID"
              control={control}
              register={register}
              // defaultValue={watch(`BankAccountID`)}
            />

            <Controller
              as={TextField}
              id="standard-basic"
              name="Description"
              label="Description"
              required
              autoComplete="off"
              control={control}
              fullWidth
              margin="dense"
              helperText={errors?.Description?.message}
              error={errors?.Description ? true : false}
              ref={register}
              defaultValue={
                formMode === 'edit' || mode === 'approve-reject'
                  ? editData?.Description
                  : ''
              }
              disabled={mode === 'approve-reject'}
              style={{
                //color: '#96938e',
                //fontSize: '14px',
                backgroundColor: 'white',
                // marginBottom: '40px',
              }}
              multiline
            />

            <VoiceTextField
              mounted={true}
              label="Remark"
              name="Remark"
              value={voiceRemark}
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              control={control}
              controllerProps={{
                error: errors?.Remark ? true : false,
                helperText: errors?.Remark?.message,
                ref: register,
                autoComplete: 'off',
              }}
            />

            <DocUploadInput
              placeholder={previewFiles.length === 0 ? 'Attachment' : null}
              label={previewFiles.length > 0 ? 'Attachment' : null}
              files={files}
              onHandleUploadChange={handleUploadChange}
              multiple
              accept={
                'application/msword, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              }
              mapData={'application'}
              imagePreview={
                <>
                  {previewFiles?.map((v, i) => (
                    <UploadPreview
                      remove
                      key={v}
                      src={v}
                      onClick={() => removeFile(i)}
                      mediaType={
                        // files[i]?.type
                        files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                      }
                    />
                  ))}
                </>
              }
              disabled={mode === 'approve-reject'}
            />
          </CardContents>
        </ContentWrapper>
      )}

      {footerOptions?.length > 0 ? (
        <Footer options={[...footerOptions]} />
      ) : null}

      <CommonDialog
        fullWidth={true}
        open={openExitDialog}
        onClose={() => setopenExitDialog(false)}
        sections={{
          header: {
            title: 'Exit Confirmation',
          },
          body: () => (
            <>
              <div>
                Are you sure you want to exit? Your changes will not be saved.
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setopenExitDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => history.goBack(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-receivable/${CompanyID}/advance`)
        }}
        // hasInfo={hasInfo}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
